import { Theme, css } from '@emotion/react';

export const defalutGrid = (theme: Theme) => css`
  ${theme.font.body}
  .title {
    color: ${theme.palette.grayscale[0]};
  }
`;
